import { Link } from "react-router-dom";
import { TextMediumSM } from "../../../../Components/Text/MediumText";
import Breadcrumb from "../../../../Components/Utils/Breadcrumb";
import { BackButton, CreateButton } from "../../../../Components/Utils/Buttons";
import { useEffect, useState } from "react";
import UseGetData from "../../../../Components/Hooks/useFetchData";
import DataTable from "../../../../Components/Others/DataTable";
import MoreOptions from "../../../../Components/Utils/MoreOptions";
import UserCard from "./UserCard";
import List from "../../../../Components/Icons/list";
import Card from "../../../../Components/Icons/card";
import Pagination from "../../../../Components/Utils/Pagenation";
import ViewMore from "./ViewMore";
import { GetAccess } from "../../../../Components/Utils/roles";
import { UserPlus } from "lucide-react";
import { HeadingWithIcon } from "../../../../Components/Utils/Settingheading";


const MainUserSettingsIndex = (id) => {
  const [page, setPage] = useState(1);
  const [pageCount, setPageCount] = useState(localStorage.getItem("perPageView")||20);
  const { data, totalCount, getData } = UseGetData(
    page,
    pageCount,
    "/user/all-users"
  );
  const [viewMode, setViewMode] = useState("list");
  
  let header = [
    {
      label: "ID",
      width: "w-[5%]",
    },
    {
      label: "Name",
      width: "w-[20%]",
    },
    {
      label: "Email",
      width: "w-[15%]",
    },
    {
      label: "Phone",
      width: "w-[15%]",
    },
    {
      label: "Role",
      width: "w-[15%]",
    },
    {
      label: "Status",
      width: "w-[12%]",
    },
    {
      label: "Action",
      width: "w-[8%]",
    },
  ];

  useEffect(() => {
    getData();
    localStorage.setItem("viewMode", viewMode);
  }, [page, pageCount, viewMode]);
  return (
    <div className="w-full h-full px-4 py-2">
      <div className="w-full sm:flex justify-between items-center">
        <Breadcrumb
          items={[
            {
              name: "Settings",
            },
            {
              name: "User",
            },
          ]}
        />
        <div className="sm:mt-0 mt-3 h-auto border rounded-full mr-3 border-baseColor-primary text-xs inline-flex justify-end w-auto flex-shrink-0 sm:justify-center overflow-hidden">
  <p className="w-auto bg-white text-black px-2 flex items-center justify-center">
    Total
  </p>
  <p className="bg-baseColor-primary w-auto text-white px-2 flex items-center justify-center">
    {totalCount || "0"}
  </p>
</div>
        <div className="flex justify-end  gap-4">
        {GetAccess('user_create')&&
          <Link to="/settings/user/create">
            <CreateButton label="User" />
          </Link>}
        <BackButton />
        </div>
      </div>
      <div className="w-full h-[calc(100vh-145px)] bg-white mt-3 mx-auto  p-2 rounded-md">
       
                     <HeadingWithIcon icon={UserPlus} title="Users" />

      {viewMode === "list" ? (
        <DataTable
          headers={header}
          total={totalCount}
          pageIndex={page}
          setPageIndex={setPage}
          dataCount={pageCount}
          setDataCount={setPageCount}
          height="h-[calc(100vh-210px)]"
          bodyHeight="max-h-[calc(100vh-280px)]"
        //    bodyHeight="max-h-[calc(100vh-260px)]"
        // height="h-[calc(100vh-145px)]"
        >
          {data &&
            data.map((item, index) => (
              <tr
                className="odd:bg-white even:bg-slate-50 hover:text-baseColor-primary hover:shadow-md hover:scale-y-105"
                key={index}
              >
                <td className="py-3 px-[4px]  w-[5%]">
                  {item?.sno || "#"}
                </td>
                <td className="py-3  text-left w-[20%]">
                <Link className='hover:text-baseColor-primary text-mainColor-400'  to={`/settings/user/view/${item?.userId}`} state={{data:item}}>              
                 {item?.name || "#"}</Link>
 
                </td>
                <td className="py-3  text-left w-[15%]">
                  {item?.email || "#"}
                </td>
                <td className="py-3  text-left w-[15%]">
                  {item?.phone?.display || "#"}
                </td>
                <td className="py-3 px-[2px] text-left w-[15%]">
                  {item?.roleName || "#"}
                </td>
                {GetAccess('user_edit') &&
                <td className="py-3 px-[2px] text-left w-[12%]">
                  {item?.status==1?"Active":"Inactive" || "#"}
                </td>}
                <td className="py-3  text-left w-[8%]">
                  {/* <MoreOptions
                    data={item}
                    fetcher={getData}
                    id={item?.userId|| ""}
                    removevalue={item?.name || "undefined"}
                    url={"/user/remove-user/"}
                    moduleName="User"
                    from={"/settings/user/"}
                    editLink={"/settings/user/edit/"}
                    viewLink={"/settings/user/view/"}
                   /> */}
                   <ViewMore  fetcher={getData} getData={getData} DeteleAccess="user_delete" EditAccess="user_edit"  removevalue={item?.name || "undefined"} data={item} id={item?.user?.id} editLink={"/settings/user/edit/"}  from={"/settings/user/"}/>
                </td>
              </tr>
            ))}
        </DataTable>
      ) : (
        <>
        <div className='w-full h-[calc(100vh-220px)] rounded-md bg-white p-3  relative overflow-y-scroll'>
      
          <div className='w-full flex justify-start flex-wrap md:gap-x-5 lg:gap-x-6 gap-y-6 '>
            {data && data.map((item, idx) => (
              <UserCard fetcher={getData} item={item} key={idx} />
            ))}
          </div>
        </div>
        <div className="w-full h-[20px] rounded-b-md bg-white">
          <Pagination
            total={totalCount}
            pageIndex={page}
            setPageIndex={setPage}
            dataCount={pageCount}
            setDataCount={setPageCount}
          />
        </div>
        </>
      )}
      </div>
    </div>
  );
};

export default MainUserSettingsIndex;
